import { axios } from "../../util/axiosConfig";
import { announcements } from "../urls";

const getAnnoucementsByCity = id =>
  axios
    .get(announcements.search, { params: { organizationId: id } })
    .then(response => response.data);

export default getAnnoucementsByCity;
